import { collection, getDocs } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../firebase/firebaseConfig";
import { format } from "date-fns";

const ViewMember = () => {
    const {memberId} = useParams();
    const [memberData, setMemberData] = useState([]);
    const [groupsData, setGroupsData] = useState([]);
    
    useEffect(() => {
        const fetchMemberData = async () => {
            const querySnapshot = await getDocs(collection(db, `Members`));
            const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    
            const member = documents.find(doc => doc.id === memberId);
    
            if (member) {
                member.MemberStart = format(timestampToDate(member.MemberStart), "dd MMMM yyyy");
                member.Attendance = format(timestampToDate(member.Attendance), "dd MMMM yyyy HH:mm");
                setMemberData(member);
    
                fetchGroupData(member.Groups);
            }
        };
    
        fetchMemberData();
    }, []); 
    
    const fetchGroupData = async (memberGroups) => {
        const querySnapshot = await getDocs(collection(db, `Groups`));
        const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    
        const matchingGroups = documents.filter(groupDoc => 
            memberGroups.some(group => group === groupDoc.Title)
        );
    
        setGroupsData(matchingGroups);
    };
    
    const timestampToDate = (timestamp) => {
      const seconds = timestamp.seconds;
      const nanoseconds = timestamp.nanoseconds;
      return new Date(seconds * 1000 + nanoseconds / 1000000);
    };

    return (
        <div>
            <div id="profile-banner" style={{height: '30vh', backgroundImage: `url(${memberData.HeaderImage})`, backgroundPosition: 'center',backgroundSize: 'cover', backgroundRepeat: 'no-repeat'}}></div>
            <div id="content" style={{padding: '15px 50px'}}>
                <div className="row">
                    <div className="col-sm-2">
                        <img src={memberData.ProfileImage} style={{width: '100%', borderRadius: "500px", marginTop: "-125px"}}/>
                    </div>
                    <div className="col-sm-6">
                        <h3>{memberData.Name} {memberData.Surname}</h3>
                        <p>{memberData.Ministry} </p>
                    </div>
                    <div className="col-sm-4">
                        
                    </div>
                </div>
                <br/>
                <br/>
                <div className="row">
                    <p className="forms-meta-data"><i>Member Since: {memberData.MemberStart}</i></p>
                    <br/>
                    <br/>
                    <p>{memberData.Description}</p>
                    <br/>
                    <br/>
                    <p className="forms-meta-data"><i>Last Attendance: {memberData.Attendance}</i></p>
                </div>
                <br/>
                <br/>
                <div className="row">
                    <h4>Groups:</h4>
                        {groupsData.map(item => {
                           return <img key={item.id} src={item.FeaturedImage} style={{width: '100px', borderRadius: "500px"}}/>
                        })}
                </div>
            </div>
        </div>
    )
}

export default ViewMember;